import type { SupplierContact } from '../../types/supplier/supplier-contact.type';
import { BaseModel } from '../base.model';

export class SupplierContactModel extends BaseModel implements SupplierContact {
  readonly id: string;
  readonly supplierId: string;
  readonly function: string | null;
  readonly firstName: string | null;
  readonly lastName: string | null;
  readonly telephone: string | null;
  readonly mobile: string | null;
  readonly note: string | null;
  readonly email: string | null;

  get fullName(): string {
    return `${this.firstName} ${this.lastName}`;
  }

  constructor(contact: SupplierContact) {
    super();

    this.id = contact.id;
    this.supplierId = contact.supplierId;
    this.function = contact.function;
    this.firstName = contact.firstName;
    this.lastName = contact.lastName;
    this.telephone = contact.telephone;
    this.mobile = contact.mobile;
    this.note = contact.note;
    this.email = contact.email;
  }

  getDisplay(): string {
    return this.fullName;
  }
}
